import React, {Component} from 'react';
import {FormSection, SectionBody} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import * as PropTypes from "prop-types";

export class OidcErrComponets extends Component {
    render() {
        return <div>
            <FormSection theme={this.props.theme}>
                <SectionBody theme={this.props.theme}>
                    <Container>
                        <Row>
                            <Col>

                                  <Card.Title>楽天ID連携エラー</Card.Title>

                            </Col>
                        </Row>
                        <Row/>

                        <div className="rakuten_errorbox">
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Header>Genelifeアカウントをまだお持ちでない方</Card.Header>
                                    <Card.Body>
                                        <Card.Title>新規登録が必要です</Card.Title>
                                        <Card.Text>
                                            楽天ID連携でログインしていただくには、新規会員登録が必要です。
                                        </Card.Text>
                                        <Button variant="primary" onClick={
                                            this.props.onClick
                                        }>新規登録はこちら</Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col>
                                <Card>
                                    <Card.Header>すでにGenelifeアカウントをお持ちの方</Card.Header>
                                    <Card.Body>
                                        <Card.Title>通常ログインが必要です</Card.Title>
                                        <Card.Text>
                                          楽天ID連携をご利用いただくには、一度、ご登録のメールアドレスとパスワードでログインをお願いいたします。ログイン後、マイページの「登録情報変更」から楽天ID連携をお願いいたします。
                                        </Card.Text>
                                        <Button variant="info" onClick={
                                            this.props.onClick1
                                        }>ログインページはこちら</Button>
                                    </Card.Body>
                                </Card>

                            </Col>
                        </Row>
                      </div>

                    </Container>
                </SectionBody>
            </FormSection>

        </div>;
    }
}

OidcErrComponets.propTypes = {
    theme: PropTypes.any,
    onClick: PropTypes.func,
    onClick1: PropTypes.func
};
